var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "template5wrapper" }, [
    _c("h2", [_vm._v(_vm._s(_vm.question.title))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.question.subTitle))]),
    _vm._v(" "),
    _c("div", { staticClass: "answersWrapper" }, [
      _vm.question.type == "number"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputValue,
                expression: "inputValue",
              },
            ],
            staticClass: "textinput",
            attrs: {
              type: "text",
              onkeyup: "this.style.width = (this.value.length+3) + 'ch';",
            },
            domProps: { value: _vm.inputValue },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.inputValue = $event.target.value
              },
            },
          })
        : _vm.question.type == "text"
        ? _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputValue,
                expression: "inputValue",
              },
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.inputValue },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.inputValue = $event.target.value
              },
            },
          })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.textError,
              expression: "textError",
            },
          ],
          staticClass: "error",
        },
        [_vm._v("\n            " + _vm._s(_vm.textErrorText) + "\n        ")]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.numberError,
              expression: "numberError",
            },
          ],
          staticClass: "error",
        },
        [_vm._v("\n            " + _vm._s(_vm.numberErrorText) + "\n        ")]
      ),
    ]),
    _vm._v(" "),
    _c("h5", [_vm._v(_vm._s(_vm.answers[0].title))]),
    _vm._v(" "),
    _c("h6", [_vm._v(_vm._s(_vm.answers[0].subTitle))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }